module.exports = __webpack_public_path__ + "static/img/wap.e3f43be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/小学/wap.svg
// module id = 2x+t
// module chunks = 16